<script lang="ts">
import { defineAsyncComponent, defineComponent } from 'vue';
import { PageStore } from 'stores/Page/Page.ts';
import { storeToRefs } from 'pinia';
import { useMeta } from 'quasar';

export default defineComponent({
  name: 'DynamicIndex',

  setup() {
    const pageStore = PageStore();
    const { currentRoute, breadcrumbs } = storeToRefs(pageStore);

    const navTitles = breadcrumbs.value.map((o) => o.name);

    useMeta({
      titleTemplate: (title) => `${title} | ${navTitles.join(' - ')}`,
    });

    return {
      currentRoute,
      currentPage: null,
    };
  },

  created() {
    if (this.currentRoute === '/' && this.$route.query.s) {
      this.currentPage = defineAsyncComponent(() => import('./IndexPages/SearchPage.vue'));
    } else if (this.currentRoute === '/') {
      this.currentPage = defineAsyncComponent(() => import('./IndexPages/IndexPage.vue'));
    } else {
      this.currentPage = defineAsyncComponent(() => import('./ErrorNotFound.vue'));
    }
  },
});
</script>

<template>
  <component :is="currentPage"></component>
</template>

<style scoped></style>
